<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptDefault :attribute="attribute" :currentCpt="currentCpt" />
    <t-form-item label="多选">
      <t-switch v-model="attribute.multiple" />
    </t-form-item>
    <!-- <t-form-item label="级联" v-if="!attribute.multiple">
      <t-switch v-model="attribute.cascade" />
    </t-form-item> -->
    <t-form-item label="是否缓存">
        <t-radio-group v-model="cptDataForm.isCache" size="small">
          <t-radio :value="false">开启</t-radio>
          <t-radio :value="true">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="默认查询">
        <t-radio-group v-model="attribute.noQuery" size="small">
          <t-radio :value="false">开启</t-radio>
          <t-radio :value="true">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
    <CptInputOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize" />
    <!-- <t-form-item label="label">
      <t-input size="small" v-model="attribute.label"/>
    </t-form-item>
    <t-form-item label="占位符">
      <t-input v-model="attribute.placeholder" size="small"/>
    </t-form-item>
    <t-form-item label="尺寸">
      <t-radio-group v-model="attribute.size">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
        <t-radio-button value="large">大</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="多选">
      <t-switch v-model="attribute.multiple"/> 
    </t-form-item>
          <e-collapse title="校验设置" :expand="true">
      <t-form-item label="必填标识">
        <t-switch
          size="small"
          v-model="attribute.required"
          :label="['是', '否']"
        />
      </t-form-item>
    </e-collapse> -->
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from "@/components/element/options/comp/cpt-default";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-select-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: {
    CptData,
    CptDefault,
    CptInputOptionBase,
  },
  data() {
    return {
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
    };
  },
  mounted() {
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>
<style scoped>
</style>